import { render, staticRenderFns } from "./PaxelRecycleBeforeSending.vue?vue&type=template&id=76af9614&"
import script from "./PaxelRecycleBeforeSending.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleBeforeSending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports